import React from 'react';
import { Button, Card, Text } from '@fragments';
import { IconChartBar, IconChevronDown } from '@tabler/icons-react';
import './styles.scss';

const EXPENSES = [
    { label: 'Housing', value: 100, tone: 'primary' },
    { label: 'Utilities', value: 64, tone: 'info' },
    { label: 'Food', value: 20, tone: 'scheduled' },
];

export default function MajorExpenses() {
    return (
        <Card
            flat
            headerDivider
            title="Major Expenses"
            icon={<IconChartBar />}
            action={
                <Button variant="text" color="inverse" size="small" endIcon={<IconChevronDown />}>
                    Weekly
                </Button>
            }
        >
            <div className="major-exp">
                {EXPENSES.map(({ label, value, tone }) => (
                    <div className="major-exp__row" key={label}>
                        <Text.label contrast={9}>{label}</Text.label>
                        <div className="major-exp__track">
                            <span className={`major-exp__bar major-exp__bar--${tone}`} style={{ width: `${value}%` }} />
                        </div>
                    </div>
                ))}

                <div className="major-exp__axis">
                    {['0', '2K', '4K', '6K', '8K', '10K'].map((label) => (
                        <Text.caption contrast={6} key={label}>{label}</Text.caption>
                    ))}
                </div>
            </div>
        </Card>
    );
}
